(function() {
  ACC.osAddress = {
    addressTypeClass: '.currentAddressType',
    osGetdeliveryAddress: function(getJsonUrl, salesOrg) {
      $.ajax({
        type: 'GET',
        url: ACC.config.contextPath + getJsonUrl,
        dataType: 'json',
        data: {
          salesOrg: salesOrg
        },
        success: function(addresslist) {
          if (addresslist) {
            ACC.osAddress.handleAddressDataLoad(addresslist, salesOrg);
          }
        }
      });
    },
    handleAddressDataLoad: function(data, salesOrg) {
      ACC.osAddress.setupDeliveryAddressPopup(data, salesOrg);

      // Show the delivery address popup
      var popupHeight = '80%';

      if ($(window).width() < 768) {
        popupHeight = '100%';
      }

      $.colorbox({
        inline: true,
        href: '#onestoreAddresspopup',
        scrolling: true,
        height: popupHeight,
        width: '100%',
        maxWidth: 640,
        overlayClose: false,
        close: '<button type=\'button\' class=\'ph-cbox-close\' id=\'ph-cboxClose\'><span class=\'ph-icon-cross\'></span></button>',
        onComplete: function() {
          ACC.common.refreshScreenReaderBuffer();
          $('#colorbox').addClass('ph-shipping-popup');
          $('#cboxContent').addClass('ph-cbox-content');
          $('html').addClass('ph-hideoverflow__shippingpopup');

          if (navigator.appVersion.indexOf('Edge') !== -1) {
            $('.ph-formlabel').addClass('ph-formlabeledge');
          }

          if ($('#cboxWrapper').find('.existing_address').length > 3) {
            $('.ph-shipping-searchaddressbox').show();
          } else {
            $('.ph-shipping-searchaddressbox').hide();
          }

          $('#cboxWrapper #myInput').each(function() {
            var inputVal = $(this).val();

            $(this).focus();
            $(this).keypress(function() {
              if (this.value === inputVal) {
                this.value = '';
              }
            });
          });

          ACC.search.searchAddress();
        },
        onClosed: function() {
          ACC.common.refreshScreenReaderBuffer();
          $('html').removeClass('ph-hideoverflow__shippingpopup');
          $('#cboxWrapper #myInput').each(function() {
            $(this).focus();
          });
        }
      });
    },
    setupDeliveryAddressPopup: function(data, salesOrg) {
      // Fill the available delivery addresses
      var addressList = data,
          currentAddressType = $(ACC.osAddress.addressTypeClass).html();

      if (currentAddressType === 'billing' && data.billingAddresses) {
        addressList = data.billingAddresses;
      }

      $('.ph-osaddresspopup_title').html($('.osAddressPopupTitle_' + currentAddressType).html());
      $('.delivery_addresses_list').html($('#deliveryAddressesTemplate').tmpl({
        addresses: addressList,
        salesOrgInput: salesOrg,
        displayCodeRegionIso: $('.displayCodeRegionIso').text()
      }));
    },
    toggleAddressBookandButtonItems: function(currentAddressType, salesOrg, addressData) {
      var $addressButtonsContainer = $('.in' + currentAddressType + '_' + salesOrg + '.ph-addressselection-buttonitems');

      $('.in' + currentAddressType + '#noAddress_' + salesOrg).addClass('ph-d-none');
      $('.in' + currentAddressType + '#selectedAddress_' + salesOrg).removeClass('ph-d-none');
      $addressButtonsContainer.removeClass('ph-d-none');

      ACC.osAddress.onestoreCheckDefault($addressButtonsContainer, addressData.defaultAddress);

      $addressButtonsContainer.find('.change_address_os').attr('data-address-id', addressData.id);
    },
    onestoreCheckDefault: function($addressButtonsContainer, isDefault) {
      var setDefaultLabel = '.ph-setdefault__label';

      if (isDefault) {
        $addressButtonsContainer.find('.ph-setdefault__tick').removeClass('hidden');
        $addressButtonsContainer.find(setDefaultLabel).addClass('ph-defaultAdd');
      } else {
        $addressButtonsContainer.find('.ph-setdefault__tick').addClass('hidden');
        $addressButtonsContainer.find(setDefaultLabel).removeClass('ph-defaultAdd');
      }
    },
    osSetAsDefaultInit: function() {
      $('.ph-setdefault__label').on('click', function() {
        var $addressButtonsContainer = $(this).parents('.ph-addressselection-buttonitems'),
            $clikedElem = $addressButtonsContainer.find('.ph-deliveryaddress__change'),
            dataAttrClass = 'data-',
            salesOrg = $clikedElem.attr(dataAttrClass + 'salesorg'),
            addressType = $clikedElem.attr('addresstype'),
            addressId = $clikedElem.attr(dataAttrClass + 'address-id'),
            setDefaultUrl = '/payment/summary/setDefaultAddressForOneStore.json';

        if (addressType === 'shipping') {
          addressType = 'delivery';
          setDefaultUrl = '/checkout/single/summary/setDefaultAddressForOneStore.json';
        }

        $.ajax({
          type: 'POST',
          url: ACC.config.contextPath + setDefaultUrl,
          data: {
            salesOrg: salesOrg,
            addressType: addressType + 'address',
            addressId: addressId
          },
          success: function(isdefault) {
            ACC.osAddress.onestoreCheckDefault($addressButtonsContainer, isdefault);
          }
        });
      });
    },
    addressDataFromResponse: function(data, currentAddressType, salesOrg) {
      var addressTypeData = data;

      if (currentAddressType === 'shipping' && data.addressData) {
        addressTypeData = data.addressData;

        if (data.oneStoreDeliveryModes) {
          ACC.osCheckout.loadDeliveryModes(data.oneStoreDeliveryModes, salesOrg);
        }
      }

      if (currentAddressType === 'billing' && data.billingAddress) {
        addressTypeData = data.billingAddress;
      }

      if (currentAddressType === 'payee' && data.payeeAddress) {
        addressTypeData = data.payeeAddress;
      }

      return addressTypeData;
    },
    showAtpfromResponse: function(data, salesOrg) {
      var customerDecision = '',
          outOfStockproducts = '';

      if (data.addressData) {
        if (data.addressData.customerDecision && data.addressData.customerDecision.length > 0) {
          customerDecision = data.addressData.customerDecision;
        }

        if (data.addressData.outOfStockproducts && data.addressData.outOfStockproducts.length > 0) {
          outOfStockproducts = data.addressData.outOfStockproducts;
        }
      }

      if (data.customerDecisionData) {
        if (data.customerDecisionData && data.customerDecisionData.length > 0) {
          customerDecision = data.customerDecisionData;
        }
      }

      ACC.osAddress.renderAtpTemplate(salesOrg, customerDecision, outOfStockproducts);

      if (data.updateEntries) {
        ACC.osAddress.refreshOnAtpData(salesOrg, 'productList');
        ACC.osAddress.refreshOnAtpData(salesOrg, 'cartTotal');
      }
    },
    renderAtpLineItem: function(salesOrg, customerDecision) {
      if (customerDecision && customerDecision.length > 0) {
        var $currentSalesOrg = $('#onestoreCartProducts_' + salesOrg);

        $.each(customerDecision, function(index, atpItem) {
          var $cartitemAtpoutofstock = $currentSalesOrg.find('#cartitemAtpoutofstock' + atpItem.productId);

          if (atpItem.quantityAvailable === 0) {
            $cartitemAtpoutofstock.show();
          } else if (atpItem.quantityRequested > atpItem.quantityAvailable) {
            $currentSalesOrg.find('#cartitemAtpinfo' + atpItem.productId).html($('#lineItemAtpDetailsTemplate').tmpl({
              quantityAvailable: atpItem.quantityAvailable,
              quantityRequested: atpItem.quantityRequested
            }));

            var $inStockEdd = $currentSalesOrg.find('#cartitemAtpinstock' + atpItem.productId);

            $inStockEdd.show();
            $inStockEdd.find('.ph-checkout_instockeddTitle').show();
            $inStockEdd.find('.ph-checkout_eddTitle').hide();
            $cartitemAtpoutofstock.show();
          }
        });
      }
    },
    renderAtpTemplate: function(salesOrg, customerDecision, outOfStockproducts) {
      $('#atpItemList' + salesOrg).html($('#atpDetailsTemplate').tmpl({
        customerDecision: customerDecision,
        outOfStockproducts: outOfStockproducts
      }));

      if ($('#atpItemList' + salesOrg + ' li').length > 0) {
        $('#atpDetailsDisplay_' + salesOrg).show();
        $('.ph-onlyforatp_' + salesOrg).show();
      } else {
        $('#atpDetailsDisplay_' + salesOrg).hide();
        $('.ph-onlyforatp_' + salesOrg).hide();
      }
    },
    refreshOnAtpData: function(salesOrg, refreshArea) {
      var reqUrl = $('.ph-refreshProductsUrl').html();

      if (refreshArea === 'cartTotal') {
        reqUrl = $('.ph-refreshCartTotalsUrl').html();
      }

      $.ajax({
        type: 'GET',
        url: ACC.config.contextPath + reqUrl,
        data: {
          salesOrg: salesOrg
        },
        success: function(responseHtml) {
          if (responseHtml && refreshArea === 'productList') {
            $('#onestoreCartProducts_' + salesOrg).html(responseHtml);
            ACC.cartpage.bindAll();
          }

          if (responseHtml && refreshArea === 'cartTotal') {
            $('#onestoreShippingOrderTotal').html(responseHtml);
            $('.ph-yourOrderprice').html($('#onestoreShippingOrderTotal').find('.ph-checkoutOrderTotal').html());
            ACC.cartpopup.bindAll();
          }
        }
      });
    },
    getAtpOnPageload: function(setAddressInput) {
      if ($('.ph-checkout-shipping').length > 0) {
        $(ACC.osAddress.addressTypeClass).html('shipping');
        $('.ph-onestore_b2bsections').each(function() {
          var salesOrg = $(this).attr('salesOrg');

          if ($('#currentAddressId_' + salesOrg).html() !== '') {
            var paramObject = {
              salesOrg: salesOrg,
              addressId: $('#currentAddressId_' + salesOrg).html(),
              setJsonUrl: '/checkout/single/summary/setDeliveryAddress.json',
              setAddress: setAddressInput
            };

            ACC.osAddress.osSetdeliveryAddress(paramObject);
          }
        });
      }
    },
    osSetdeliveryAddress: function(paramObject) {
      var currentAddressType = $(ACC.osAddress.addressTypeClass).html(),
          postData = {
            salesOrg: paramObject.salesOrg,
            setAddress: paramObject.setAddress
          };

      if (currentAddressType === 'payee') {
        postData.payerAddressId = paramObject.addressId;
      } else {
        postData.addressId = paramObject.addressId;
      }

      $.ajax({
        type: 'POST',
        url: ACC.config.contextPath + paramObject.setJsonUrl,
        dataType: 'json',
        data: postData,
        success: function(data) {
          if (data && currentAddressType === 'shipping' && paramObject.setAddress === false) {
            ACC.osAddress.showAtpfromResponse(data, paramObject.salesOrg);
          } else if (data) {
            if (currentAddressType === 'shipping') {
              ACC.osAddress.showAtpfromResponse(data, paramObject.salesOrg);
              ACC.osAddress.handleShippingAddressErrorHidden();
            }

            var addressData = ACC.osAddress.addressDataFromResponse(data, currentAddressType, paramObject.salesOrg);

            $('.in' + currentAddressType + '#selectedAddress_' + paramObject.salesOrg).html($('#addressTemplate').tmpl({
              address: addressData,
              displayCodeRegionIso: $('.displayCodeRegionIso').text()
            }));
            ACC.osAddress.toggleAddressBookandButtonItems(currentAddressType, paramObject.salesOrg, addressData);
            $.colorbox.toggleLoadingOverlay();
            $.colorbox.close();
          }
        }
      });
    },

    handleShippingAddressErrorHidden: function() {
      if ($('.ph-noaddress_section').is(':hidden')) {
        $('.ph-selectshippingaddress__errormsg--main').addClass('hidden');
      }
    },

    handleShippingAddressErrorVisible: function() {
      if ($('.ph-noaddress_section').is(':visible')) {
        $('.ph-selectshippingaddress__errormsg--main').removeClass('hidden');
      }
    }
  };

  $(document).ready(function() {
    if ($('.ph-onestore_checkout').length > 0) {
      $('.change_address_os').on('click', function() {
        var salesOrg = $(this).attr('data-salesOrg'),
            getJsonUrl = '/checkout/single/summary/getDeliveryAddressesForOneStore.json',
            addressType = $(this).attr('addressType');

        if (addressType === 'shipping') {
          getJsonUrl = '/checkout/single/summary/getDeliveryAddressesForOneStore.json';
        } else if (addressType === 'billing') {
          getJsonUrl = '/payment/summary/getBillingAddresses.json';
        } else if (addressType === 'payee') {
          getJsonUrl = '/payment/summary/getPayeeAddresses.json';
        }

        $(ACC.osAddress.addressTypeClass).html(addressType);
        ACC.osAddress.osGetdeliveryAddress(getJsonUrl, salesOrg);
      });
      $(document).on('click', '.set_address_os', function() {
        var paramObject = {
              salesOrg: $(this).attr('data-salesOrg'),
              addressId: $(this).attr('data-address-id'),
              setJsonUrl: '',
              setAddress: true
            },
            addressType = $(ACC.osAddress.addressTypeClass).html();

        if (addressType === 'shipping') {
          paramObject.setJsonUrl = '/checkout/single/summary/setDeliveryAddress.json';
        } else if (addressType === 'billing') {
          paramObject.setJsonUrl = '/payment/summary/setBillingAddress.json';
        } else if (addressType === 'payee') {
          paramObject.setJsonUrl = '/payment/summary/setPayeeAddresses.json';
        }

        ACC.osAddress.osSetdeliveryAddress(paramObject);
      });
      ACC.osAddress.osSetAsDefaultInit();
      ACC.osAddress.getAtpOnPageload(false);
    }
  });
})();

